// The countries a billing address can name, by ISO 3166-1 alpha-2 code — the
// form the API and Stripe both take.
//
// Held here rather than read from /Languages/getAllCountries for two reasons.
// The billing page is where an organization held at billing_only lands, and
// every call outside the billing, account and credits endpoints answers it with
// a 402 — a country list fetched from anywhere else would come back empty on
// exactly the page that needs it. And the list has to include Kosovo (XK),
// which is not an officially assigned code, but is the one Kosovo's businesses
// are billed under.
//
// Names come from the browser (Intl.DisplayNames), so nothing here goes stale;
// a browser without it shows the code itself.

const REGION_CODES = (
   "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ " +
   "BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM " +
   "DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS " +
   "GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN " +
   "KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ " +
   "MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM " +
   "PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV " +
   "SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI " +
   "VN VU WF WS YE YT ZA ZM ZW XK"
).split(" ");

export const COUNTRY_CODES = Object.freeze(REGION_CODES);

let displayNames;

/** A country's name in English, or its code when the browser cannot name it. */
export const getCountryName = (code) => {
   if (!code) return "";

   try {
      displayNames = displayNames ?? new Intl.DisplayNames(["en"], { type: "region" });
      return displayNames.of(code) || code;
   } catch (unsupported) {
      return code;
   }
};

let countryOptions;

/** Every country as a select option, alphabetical by name. Built once. */
export const getCountryOptions = () => {
   countryOptions =
      countryOptions ??
      REGION_CODES.map((code) => ({ value: code, label: getCountryName(code) })).sort((a, b) =>
         a.label.localeCompare(b.label)
      );

   return countryOptions;
};
